<ng-template #header>
  <div class="mb-4">
    <app-button [text]="'<'" [matButtonAparence]="'tonal'" [href]="'/'+backUrl()" type="button"></app-button>
  </div>
</ng-template>
<ng-template #content>
  <app-titledescription [title]="'Agregar '+title" [description]="description"></app-titledescription>
  <app-form #formGeneral [fields]="fields" [backUrl]="'/'+backUrl()" (selectFieldValueEmit)="selectFieldValueEmit.emit($event)"></app-form>
</ng-template>
<ng-template #actions>
  <div class="flex gap-2 mb-4 ml-4">
    <app-button text="Guardar" (click)="submit()"></app-button>
    <app-button (click)="navigateToBack()" text="Cancelar" [matButtonAparence]="'tonal'" type="button"></app-button>
  </div>
</ng-template>
<app-card [templateRefHeader]="header" [templateRefContent]="content" [templateRefFooter]="actions"></app-card>
